<template>
  <div
    :class="$route.path.includes('products') ? 'inside-product__wrapper2' : 'inside-product__wrapper' "
    style="
      flex-grow: 0.8;
      display: flex;
      flex-direction: column;
      align-items: flex;
      width:auto;
    "
    :style="$route.path.includes('products') ? 'margin-top: 112px' : getStyle()"
  >
    <!-- <div
      class="table__header"
      style="margin-bottom: 13px !important;margin-top: -12px;"
    >
      <button
        v-if="$route.path.includes('create-order') && getDressColors.length == 0"
        v-b-modal.add-custom
        class="button"
        style="border-radius:6px"
        @click="getMaterialVByMandP"
      >
        <b-icon-plus />
        Add Custom Dress
      </button>
    </div> -->
    <div class="insideProductTable">
      <table
        class="team_table"
        :class="{'button--disabled': getMaterialsByArticleNum.length == 0 }"
      >
        <thead>
          <tr>
            <th>
              {{ $t('MaterialVariantName') }}
            </th>
            <th>
              {{ $t('Photo') }}
            </th>
            <th>
              {{ $t('Unit') }}
            </th>
            <th>
              {{ $t('Details') }}
            </th>
            <!-- <th style="padding: 10px; border-radius: 0px 0px 0px 0px;   color: #262E6C !important; font-size: 15px;">
              {{ $t('TotalCost') }}
            </th> -->
          </tr>
        </thead>
        <tbody
          v-if="getMaterialsByArticleNum.productSingleMaterialVariantDtos"
        >
          <tr
            v-for="item in getMaterialsByArticleNum.productSingleMaterialVariantDtos"
            :key="item.materialVariantId"
            style="cursor: pointer"
          >
            <td>
              {{ item.name }}
            </td>
            <td
              v-if="item.fileUrl"
              style="padding: 9px;"
            >
              <img
                v-b-tooltip="$t('ClickToViewImg')"
                style="height: 40px; border-radius: 3px; "
                :src="item.fileUrl"
                alt="image"
                @click.stop="getAllImages(item)"
              >
            </td>
            <td v-else>
              <img
                v-b-tooltip="$t('NoImageOrDocument')"
                style="width:30px;height:30px"
                src="../../assets/images/noImageAvailable.svg"
              >
            </td>
            <td>
              <template v-if="item.quantity > 0">
                {{ item.quantity }} {{ item.quantity === 1 ? $t('Part') : $t('Parts') }}
              </template>
              <template v-else-if="item.length > 0">
                {{ item.length }} {{ item.length === 1 ? $t('Meter') : $t('Meters') }}
              </template>
            </td>
            <td class="actiontd">
              <button
                v-if="!showStockLocation"
                class="editButton"
                @click="toggleStockLocation(item.materialVariantId, $event)"
              >
                {{ $t('Stock') }}
              </button>
              <button
                v-if="showStockLocation"
                class="editButton"
                @click="toggleStockLocation(item.materialVariantId, $event)"
              >
                {{ $t('Stock') }}
              </button>

              <div
                v-if="showPopup[item.materialVariantId]"
                class="popup stockPopUp"
              >
                <table class="team_table">
                  <thead>
                    <tr>
                      <th>{{ $t('Total') }}</th>
                      <th>{{ $t('Location') }}</th>
                    </tr>
                  </thead>
                  <tbody v-if="Array.isArray(getCurrentStockAmountByLocation)">
                    <tr
                      v-for="stock in getCurrentStockAmountByLocation"
                      :key="stock.locationName"
                    >
                      <td>{{ stock.totalStock }}</td>
                      <td>{{ stock.locationName }}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td>{{ getCurrentStockAmountByLocation.totalStock }}</td>
                      <td>{{ getCurrentStockAmountByLocation.locationName }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td
              colspan="5"
              style="text-align: center; background: #F9FAFB"
            >
              {{ $t('EstimatedProductionTime') }}
            </td>
          </tr>
          <tr>
            <td>
              <div style="display: flex; flex-direction: column; align-items: center; border: 2px solid #EAECF0; padding: 10px; width: 130px; background-color: #F9FAFB">
                <div>
                  <img
                    src="../../assets/images/prodmanagementTime.svg"
                    alt=""
                  >
                </div>
                <div class="minutes">
                  <input
                    type="number"
                    v-model="patternMinutes[getMaterialsByArticleNum.id]"
                    min="0"
                    :placeholder="patternPlaceholder"
                    style="width: 100%; margin-top: 8px; text-align: center;"
                    @input="debouncedUpdatePatternTime($event.target.value)"
                  />
                  <span style="margin-bottom: 4px; color: #888; text-align: center;">
                    {{ getMaterialsByArticleNum.estimattedProductionJson != null ? getMaterialsByArticleNum.estimattedProductionJson.patternInMinutes : 0 }} min
                  </span>
                </div>
              </div>
            </td>
            <td>
              <div style="display: flex; flex-direction: column; align-items: center; border: 2px solid #EAECF0; padding: 10px; width: 150px; background-color: #F9FAFB">
                <div>
                  <img
                    src="../../assets/images/sewingTime.svg"
                    alt=""
                  >
                </div>
                <div class="minutes">
                  <input
                    type="number"
                    v-model="sewingMinutes[getMaterialsByArticleNum.id]"
                    min="0"
                    :placeholder="sewingPlaceholder"
                    style="width: 100%; margin-top: 8px; text-align: center;"
                    @input="debouncedUpdateSewingTime($event.target.value)"
                  />
                  <span style="margin-bottom: 4px; color: #888; text-align: center;">
                    {{ getMaterialsByArticleNum.estimattedProductionJson != null ? getMaterialsByArticleNum.estimattedProductionJson.sewingInMinutes : 0 }} min
                  </span>
                </div>
              </div>
            </td>
            <td>
              <div style="display: flex; flex-direction: column; align-items: center; border: 2px solid #EAECF0; padding: 10px; width: 150px; background-color: #F9FAFB">
                <div>
                  <img
                    src="../../assets/images/embroideryTime.svg"
                    alt=""
                  >
                </div>
                <div class="minutes">
                  <input
                    type="number"
                    v-model="embroideryMinutes[getMaterialsByArticleNum.id]"
                    min="0"
                    :placeholder="embroideryPlaceholder"
                    style="width: 100%; margin-top: 8px; text-align: center;"
                    @input="debouncedUpdateEmbroideryTime($event.target.value)"
                  />
                  <span style="margin-bottom: 4px; color: #888; text-align: center;">
                    {{ getMaterialsByArticleNum.estimattedProductionJson != null ? getMaterialsByArticleNum.estimattedProductionJson.embroideryInMinutes : 0 }} min
                  </span>
                </div>
              </div>
            </td>
          </tr>
          <tr
            v-if="getMaterialsByArticleNum.totalCost > 0"
            style="text-align: center; background: #F9FAFB"
          >
            <td
              colspan="5"
            >
              {{ $t("TotalPriceForVariants") }}
            </td>
          </tr>
          <tr
            v-if="getMaterialsByArticleNum.totalCost > 0"
            style="text-align: center;"
          >
            <td
              colspan="5"
            >
              {{ numbersWithcomma(getMaterialsByArticleNum.totalCost) }} €
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <CreateCustomOrderModal
      @createCustomOrder="createCustomOrder"
    /> -->
    <vue-easy-lightbox
      :esc-disabled="false"
      move-disabled
      :visible="image.visible"
      :imgs="image.imgs"
      :index="image.index"
      @hide="handleHide"
    />
    <!-- <ViewVariantStockLocation /> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VueEasyLightbox from 'vue-easy-lightbox'
// import ViewVariantStockLocation from '@/components/products/modals/ViewVariantStockLocation.vue'
// import CreateCustomOrderModal from '@/modals/CreateCustomOrderModal.vue';

export default {
  components: {
    VueEasyLightbox,
    // ViewVariantStockLocation,
    // eslint-disable-next-line vue/no-unused-components
    // CreateCustomOrderModal,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    productMatObj: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    addedArticle: {
      type: Array,
    },
    createOrder: {
      type: Boolean,
    },
    inventoryProductsOfId: {
      type: String,
    },
    articleNumberOfProduct: {
      type: String,
    },
  },
  data() {
    return {
      showStockLocation: false,
      showPopup: {},
      dummy: '',
      searchTerm: '',
      rows: [],
      idOfArticle: '',
      image: {
        zoom: 1,
        imgs: [], // Img Url , string or Array of string
        visible: false,
        index: 0, //
      },
      patternMinutes: {}, // Add this
      sewingMinutes: {}, // Add this
      embroideryMinutes: {}, // Add this
      debouncedUpdatePatternTime: null,
      debouncedUpdateSewingTime: null,
      debouncedUpdateEmbroideryTime: null,
    };
  },
  computed: {
    ...mapGetters(['getMaterialsByArticleNum', 'getDressColors', 'getCurrentStockAmountByLocation']),

    // Add computed properties for placeholders
    patternPlaceholder() {
      const productionData = this.getMaterialsByArticleNum.estimattedProductionJson;
      return productionData?.patternInMinutes && productionData.patternInMinutes > 0 ? '' : this.$t('EnterMinutes');
    },
    sewingPlaceholder() {
      const productionData = this.getMaterialsByArticleNum.estimattedProductionJson;
      return productionData?.sewingInMinutes && productionData.sewingInMinutes > 0 ? '' : this.$t('EnterMinutes');
    },
    embroideryPlaceholder() {
      const productionData = this.getMaterialsByArticleNum.estimattedProductionJson;
      return productionData?.embroideryInMinutes && productionData.embroideryInMinutes > 0 ? '' : this.$t('EnterMinutes');
    },
  },
  watch: {
    productMatObj() {
      this.addRows();
    },
    // Watch for changes in the article ID
    'getMaterialsByArticleNum.id': {
      handler(newId, oldId) {
        if (newId !== oldId) {
          // Clear values for the old article
          if (oldId) {
            this.patternMinutes[oldId] = '';
            this.sewingMinutes[oldId] = '';
            this.embroideryMinutes[oldId] = '';
          }
          // Initialize values for the new article
          this.resetInputValues();
        }
      },
      immediate: true,
    },
    // Add this watcher to initialize input values
    'getMaterialsByArticleNum.estimattedProductionJson': {
      handler(newValue) {
        const id = this.getMaterialsByArticleNum.id;

        // Clear previous values first
        this.patternMinutes[id] = '';
        this.sewingMinutes[id] = '';
        this.embroideryMinutes[id] = '';

        if (newValue) {
          // Initialize with existing values only if they exist and are greater than 0
          if (newValue.patternInMinutes && newValue.patternInMinutes > 0) {
            this.patternMinutes[id] = newValue.patternInMinutes;
          }
          if (newValue.sewingInMinutes && newValue.sewingInMinutes > 0) {
            this.sewingMinutes[id] = newValue.sewingInMinutes;
          }
          if (newValue.embroideryInMinutes && newValue.embroideryInMinutes > 0) {
            this.embroideryMinutes[id] = newValue.embroideryInMinutes;
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);

    // Initialize debounced functions
    this.debouncedUpdatePatternTime = this.debounce((newValue) => {
      this.updateTimeWithValue('pattern', newValue);
    }, 500);

    this.debouncedUpdateSewingTime = this.debounce((newValue) => {
      this.updateTimeWithValue('sewing', newValue);
    }, 500);

    this.debouncedUpdateEmbroideryTime = this.debounce((newValue) => {
      this.updateTimeWithValue('embroidery', newValue);
    }, 500);

    // Initialize input values
    this.resetInputValues();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    ...mapActions(['getCurrentStockAndLocationByVariantId', 'addOrderInStore', 'productsByArticleNumber', 'getMaterialVariantsToMDCPagination', 'updatePatternTime', 'updateEmbroideryTime', 'updateSewingTime']),
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    async updateTimeMinus(type, value) {
      if (type == 'pattern') {
        let newTime
        if (value == null) {
          newTime = 0 - 1;
        } else {
          newTime = value.patternInMinutes - 1;
        }
        await this.updatePatternTime({
          inventoryId: this.inventoryProductsOfId,
          newPatternTime: newTime,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      } else if (type == 'sewing') {
        let newTime
        if (value == null) {
          newTime = 0 - 1;
        } else {
          newTime = value.sewingInMinutes - 1;
        }
        await this.updateSewingTime({
          inventoryId: this.inventoryProductsOfId,
          newSewingTime: newTime,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      } else if (type == 'embroidery') {
        let newTime
        if (value == null) {
          newTime = 0 - 1;
        } else {
          newTime = value.embroideryInMinutes - 1;
        }
        await this.updateEmbroideryTime({
          inventoryId: this.inventoryProductsOfId,
          newEmbroideryTime: newTime,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      }
    },
    async updateTimeWithValue(type, newValue) {
      console.log('type', type, 'newValue', newValue);
      const numericValue = parseInt(newValue, 10) || 0;

      if (type == 'pattern') {
        await this.updatePatternTime({
          inventoryId: this.inventoryProductsOfId,
          newPatternTime: numericValue,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      } else if (type == 'sewing') {
        await this.updateSewingTime({
          inventoryId: this.inventoryProductsOfId,
          newSewingTime: numericValue,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      } else if (type == 'embroidery') {
        await this.updateEmbroideryTime({
          inventoryId: this.inventoryProductsOfId,
          newEmbroideryTime: numericValue,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      }
    },
    toggleStockLocation(id, event) {
      event.stopPropagation(); // Prevents the click from closing the popup immediately
      this.showPopup = { ...this.showPopup, [id]: !this.showPopup[id] };
      if (this.showPopup[id]) {
        this.stockLocationDetails({ materialVariantId: id });
      } else {
        this.hideStockLocation();
      }
    },
    stockLocationDetails(value) {
      this.materialVariantId = value.materialVariantId
      this.showStockLocation = true
      this.getCurrentStockAndLocationByVariantId({ materialVariantId: value.materialVariantId })
    },
    hideStockLocation() {
      this.showStockLocation = false
    },
    handleClickOutside(event) {
      const popup = this.$el.querySelector('.popup');
      if (popup && !popup.contains(event.target)) {
        this.showPopup = {}; // Close all popups
      }
    },
    matProps(value) {
      this.materialVariantId = value.materialVariantId
      console.log('MaterialVariantId', this.materialVariantId)
      console.log('Getter', this.getCurrentStockAmountByLocation)
      this.getCurrentStockAndLocationByVariantId({ materialVariantId: value.materialVariantId })
    },

    async getAllImages(item) {
      console.log('itemi', item)
      this.image.imgs = [];
      this.image.imgs.push({
        src: item.fileUrl,
      });
      this.show();
    },
    show() {
      this.image.visible = true
    },

    handleHide() {
      this.image.visible = false
      this.image.imgs.length = []
    },

    numbersWithcomma(value) {
      const options = {
        style: 'decimal', // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      return value.toLocaleString('en-US', options);
    },
    async createCustomOrder(obj) {
      await this.addOrderInStore(obj);
    },
    getStyle() {
      if (this.getDressColors.length != 0) {
        return 'margin-top: 112px'
      // eslint-disable-next-line no-else-return
      } else {
        return 'margin-top: 112px'
      }
    },
    addRows() {
      const x = this.productMatObj.productMaterialVariantDtos;
      const y = this.productMatObj.productMaterialQuantityDtos;

      this.rows = [...x, ...y];
    },

    // tdClass(row) {
    //   return row.vgtSelected ? 'row-clicked' : '';
    // },

    // onRowClick(p) {
    //   return p.selected ? 'selected' : '';
    // },
    async getMaterialVByMandP() {
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Meter',
      });
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Part',
      });
    },
    // Add this method to reset input values
    resetInputValues() {
      const id = this.getMaterialsByArticleNum.id;
      const productionData = this.getMaterialsByArticleNum.estimattedProductionJson;

      if (productionData) {
        // Only set values if they exist and are greater than 0
        if (productionData.patternInMinutes && productionData.patternInMinutes > 0) {
          this.patternMinutes[id] = productionData.patternInMinutes;
        }
        if (productionData.sewingInMinutes && productionData.sewingInMinutes > 0) {
          this.sewingMinutes[id] = productionData.sewingInMinutes;
        }
        if (productionData.embroideryInMinutes && productionData.embroideryInMinutes > 0) {
          this.embroideryMinutes[id] = productionData.embroideryInMinutes;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.popup {
  width: 270px;
  height: auto;
  border-radius: 8px;
  border: 1px solid lightgray;
  background: white;
  position: absolute;
  top: calc(100% - 10px);
  left: 88%;
  transform: translateX(-50%);
  z-index: 1;
}

.actiontd {
  position: relative;
}
.minutes {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.insideProductTable {
  width: 60%;
  padding-top: 16px
}
.team_table td {
  padding: 16px 10px !important;
}

.team_table th {
  padding: 10px;
}

.team_table th:first-child {
  border-radius: 0px 0px 0px 0px;
}

.team_table th:last-child {
  border-radius: 0px 0px 0px 0px;
}
.orange-color {
  color: orange;
}
.red-color {
  color: red;
}
.green-color {
  color: green;
}
.team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}

tr:last-child {
  border-bottom: none !important;
}
@media screen and (max-width: 1823px) {
  .inside-product__wrapper{
    margin-left: 20px;
  }
  .inside-product__wrapper2{
    width:100% !important;
  }
}
@media screen and (max-width: 1623px) {
  .inside-product__wrapper{
    margin-left: 20px;
  }
  .inside-product__wrapper2{
    width:100% !important;
  }
}
@media screen and (max-width: 1400px) {
.inside-product__wrapper{
  width: 200px !important;
  margin-left: 0px !important;
  // button{
  //   font-size: 11px;
  //   width: 100% !important;
  //   height: 36px;
  // }
}
.inside-product__wrapper2{
    width:100% !important;
  }
  .insideProductTable {
    width: 100%;
  }
  .popup {
    width: 270px;
    height: auto;
    border-radius: 8px;
    border: 1px solid lightgray;
    background: white;
    position: absolute;
    top: calc(100% + 0px); /* Adjust this value based on your design */
    left: 25%;
    transform: translateX(-50%);
    z-index: 1;
  }
}

@media screen and (max-width: 1200px) {
  .inside-product__wrapper2 {
    margin-top: 30px !important;
    width: 100%;
  }
  .insideProductTable {
    width: 100%;
  }
}
@media screen and (max-width: 896px) {
  .inside-product__wrapper {
    width: auto !important;
    flex-basis: 50%;
  }
}
</style>
